import { css, Theme } from '@emotion/react'

export const tabContent = (isVisible?: boolean) => css`
  display: ${isVisible ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
`

export const copyButton = css`
  width: 135px;
  margin-right: -10px;
`

export const greSectionsHint = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
`

export const slugAdornment = (isError?: boolean) => (theme: Theme) =>
  css`
    color: ${isError ? theme.colors.red : theme.typographyColors.typographyThree};
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    margin-right: -9px;
  `
